import React, { useContext } from 'react';
import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import AlertContext from 'shared/contexts/AlertContext';

const CustomSnackbar: React.FC = () => {
  const [alert, setAlert] = useContext(AlertContext);
  const [message, severity] = alert || [null, ''];

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(message)}
      autoHideDuration={6000}
      onClose={() => setAlert(null)}
    >
      <MuiAlert onClose={() => setAlert(null)} severity={severity}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default CustomSnackbar;
